import { isTestMode } from '../lib/test-mode'

// Conditional re-export: proxy-based client for test mode, Neon Data API for production
const mod = isTestMode
  ? await import('./db-test')
  : await import('./db-neon')

export const fetchMachineProfiles = mod.fetchMachineProfiles
export const insertMachineProfile = mod.insertMachineProfile
export const updateMachineProfile = mod.updateMachineProfile
export const deleteMachineProfile = mod.deleteMachineProfile

export const fetchToolLibraries = mod.fetchToolLibraries
export const insertToolLibrary = mod.insertToolLibrary
export const updateToolLibrary = mod.updateToolLibrary
export const deleteToolLibrary = mod.deleteToolLibrary

export const fetchJobs = mod.fetchJobs
export const insertJob = mod.insertJob
export const updateJob = mod.updateJob
export const deleteJob = mod.deleteJob

export const insertMessage = mod.insertMessage
export const flagMessage = mod.flagMessage

export const fetchJobsByIds = mod.fetchJobsByIds
export const fetchJobByToken = mod.fetchJobByToken
export const fetchJobSummaries = mod.fetchJobSummaries
export const closeJob = mod.closeJob
export const reopenJob = mod.reopenJob
export const touchJob = mod.touchJob

export type { ToolLibraryRow } from './db-mappers'
